import React, { useEffect, useRef, useState } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import MagicalBackground from "./MagicalBackground";
import "./Landing.css";

interface LandingProps {
  onEarlyAccessClick?: () => void;
}

const Landing: React.FC<LandingProps> = ({ onEarlyAccessClick }) => {
  const ref = useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end start"],
  });

  const [showLogo, setShowLogo] = useState(false);

  const y = useTransform(scrollYProgress, [0, 1], ["0%", "50%"]);

  useEffect(() => {
    // Show logo after a delay
    const timer = setTimeout(() => {
      setShowLogo(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="landing" className="landing-section" ref={ref}>
      <div className="landing-container">
        {/* Left Side - Image */}
        <motion.div className="hero-image-side" style={{ y }}>
          <img src="landingart.webp" alt="Seekers Character" />
        </motion.div>

        {/* Right Side - Content */}
        <motion.div className="hero-content-side">
          {/* Magical Background Effects */}
          <MagicalBackground />

          <div className="content-wrapper">
            {/* Main Logo - Animated entrance */}
            {showLogo && (
              <motion.div
                className="hero-logo"
                initial={{ opacity: 0, scale: 0.8, y: 50 }}
                animate={{ opacity: 1, scale: 1, y: 0 }}
                transition={{
                  duration: 1.2,
                  ease: [0.25, 0.46, 0.45, 0.94],
                }}
              >
                <img src="logo.webp" alt="Seekers: Shards of Imriel" />
              </motion.div>
            )}

            {/* Tagline */}
            <motion.div
              className="hero-tagline"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 1.3, duration: 0.8 }}
            >
              <h3>
                Customize your character, build your deck,
                <br />
                and conquer your rivals.
              </h3>
            </motion.div>

            {/* Call to Action */}
            <motion.div
              className="hero-cta"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 1.5, duration: 0.8 }}
            >
              <button
                onClick={() => {
                  scrollToSection("about");
                  onEarlyAccessClick?.();
                }}
                className="btn hero-btn"
              >
                CLAIM THE SHARDS
              </button>
            </motion.div>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      {/* <motion.div
        className="scroll-indicator"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 2.5, duration: 0.8 }}
      >
        <p>scroll to explore</p>
        <div className="scroll-arrow"></div>
      </motion.div> */}
    </section>
  );
};

export default Landing;
